<div class="eod-textarea input--sm">
    <label class="form-label" [ngClass]="{'disabled': to.disabled}">
        {{field.templateOptions.label}}@if(to.required){<span>*</span>}
    </label>
    <textarea draggable="true" autosize id="{{ 'txtarea' + fieldKey }}" [readonly]="to.readonly"
        [formControl]="formControl" [formlyAttributes]="field"
        class="form-control"
        [ngClass]="{'disabled': to.disabled, }"
        (input)="onTextInput()">
    </textarea>
    @if(formControl.errors && formControl.errors.required && isFormSubmitted){<div class="bottom-helper-text">
        @if(!formControl.value || !formControl.value.trim()){<small class="helper-text">{{ "label_Required" | translate: param }}</small>}
    </div>}
    @if(field.templateOptions.note && field.templateOptions.note && field.templateOptions.maxLength &&
    field.templateOptions.maxLengthCount){<div class="bottom-helper-text">
        @if(field.templateOptions.note && field.templateOptions.note){<small>
            {{field.templateOptions.note}}
        </small>}
        @if(field.templateOptions.maxLength && field.templateOptions.maxLengthCount){<small>
            {{formControl.value ? formControl.value.length : 0}} / {{ field.templateOptions.maxLength}}
        </small>}
    </div>}
</div>